import React from 'react';
import isChildType from './isChildType.js';

var findByType = function findByType(children, component) {
  /* This is the array of result since Article can have multiple times the same sub-component */
  var result = [];
  /* Then we go through each React children, if one of matches the name of the sub-component we’re looking for we put it in the result array */

  React.Children.forEach(children, function (child) {
    if (isChildType(child, component)) {
      result.push(child);
    }
  }); // Return first result;

  return result[0];
};

export default findByType;
export { findByType };